<template>
  <div class="mt-2">
    <div class="row">
      <div class="col-md-4">
        <div class="row ">
          <div class="col-md-12">
          <v-card>
            <v-card-title class="headline">
              Solicitud de Afiliación
            </v-card-title>
            <v-card-text>
            <v-switch
                :color="themeColor"
                v-model="this.switch"
                @click.prevent="openModalStatus()"
              />
            <span v-if="this.modo === 3"> Activo</span>
            <span v-else> Inactivo</span>
            </v-card-text>
          </v-card>
          </div>
        </div>
        <div class="row">
      <div class="col-md-12" v-if="this.modo === 3" >
          <v-card>
            <v-card-title class="headline">
              Generación de QR
            </v-card-title>
            <v-card-text>
            <v-switch
                :color="themeColor"
                v-model="this.switchQR"
                @click.prevent="openModalStatusQR()"
              />
            <span v-if="this.modoqr === 1"> Activo</span>
            <span v-else> Inactivo</span>
            </v-card-text>
          </v-card>
      </div>
        </div>
      </div>

      <div class="col-md-8" v-if="this.modoqr === 1">
          <v-card>
            <v-card-text>
            <qr-code :text="qr_security_code"></qr-code>
            </v-card-text>
          </v-card>
      </div>
      <v-dialog
        v-model="dialogStatus"
        max-width="750"
      >
        <v-card>
          <v-card-title class="headline">
            ¿Estás seguro de que quieres modificar este registro?
          </v-card-title>
          <v-card-title>
            {{this.msj}}
          </v-card-title>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="error darken-1"
              text
              @click="dialogStatus = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              :loading="loading"
              @click.prevent="toggleAfiliacion()"
            >
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogStatusQR"
        max-width="750"
      >
        <v-card>
          <v-card-title class="headline">
            ¿Estás seguro de que quieres modificar este registro?
          </v-card-title>
          <v-card-title>
            {{this.msjQR}}
          </v-card-title>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="error darken-1"
              text
              @click="dialogStatusQR = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              :loading="loading"
              @click.prevent="toggleGenerar()"
            >
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import Form from 'vform';
import { mapGetters } from 'vuex';
// import VuetifyTable from '~/components/VuetifyTable';

export default {
  middleware: 'auth',
  components: {
    // VuetifyTable,
  },
  props: {
    enterpriseId: { default: null },
  },
  data: () => ({
    form: new Form({
      valor: '',
      valorQR: '',
    }),
    msj: '',
    msjQR: '',
    qr_security_code: '',
    switch: false, // MODO PAC
    switchQR: false,
    modo: '',
    modoqr: '',
    dialogStatus: false,
    dialogStatusQR: false,
    loading: false,
    rules: {
      required: (v) => !!v || 'El campo es requerido.',
    },
    apiURLBase: '/api/enterprises',
  }),
  computed: {
    enterprise() {
      return this.$store.state.profile.enterprise;
    },
    ...mapGetters({
      themeColor: 'theme/themeColor',
    }),
  },
  async mounted() {
       // Afiliación QR
      await this.getAfiliacionQR().then((result) => {
        const modoAfiliacion = result.data.value;
        if (modoAfiliacion === 1) {
          this.modo = 3;
          this.switch = true;
          this.form.valor = 4;
          this.msj = 'Desea dar de baja la afiliación QR';
        } else {
          this.modo = 4;
          this.switch = false;
          this.form.valor = 3;
          this.msj = 'Desea solicitar la afiliación QR';
        }
      });

      await this.getGenerarQR().then((result) => {
        const modoGenerar = result.data.value;
        if (modoGenerar === 1) {
          this.modoqr = 1;
          this.switchQR = true;
          this.form.valorQR = 2;
          this.qr_security_code = result.data.item;
          this.msjQR = 'Desea Anular el código de segurdad QR';
        } else {
          this.modoqr = 2;
          this.switchQR = false;
          this.form.valorQR = 1;
          this.msjQR = 'Desea generar el código de seguridad QR';
        }
      });
  },
  methods: {
    openModalStatus() {
      this.dialogStatus = true;
    },
    openModalStatusQR() {
      this.dialogStatusQR = true;
    },
    toggleAfiliacion() {
     this.loading = true;
      const url = `${this.apiURLBase}/${this.enterprise.id}/others/update`;
      window.axios.put(url, {
          type_request: this.form.valor,
        })
        .then((response) => {
          this.loading = false;
          this.action = 'loading';
          this.$store.dispatch('notifications/show', {
            message: response.data.message,
            type: response.data.type,
          });
          this.dialogStatus = false;
          if (this.form.valor === 3) {
            this.switch = true;
            this.modo = 3;
          } else {
            this.switch = false;
            this.modo = 4;
          }

          this.getAfiliacionQR().then((result) => {
            this.modo = result.data.value;
            if (this.modo === 1) {
              this.modo = 3;
              this.switch = true;
              this.form.valor = 4;
              this.msj = 'Desea dar de baja la afiliación QR';
            } else {
              this.modo = 4;
              this.switch = false;
              this.form.valor = 3;
              this.msj = 'Desea solicitar la afiliación QR';
            }
          });
        });
    },
    toggleGenerar() {
     this.loading = true;
      const url = `${this.apiURLBase}/${this.enterprise.id}/others/update`;
      window.axios.put(url, {
          type_request: this.form.valorQR,
        })
        .then((response) => {
          this.loading = false;
          this.action = 'loading';
          this.$store.dispatch('notifications/show', {
            message: response.data.message,
            type: response.data.type,
          });
          this.dialogStatusQR = false;
          if (this.form.valorQR === 1) {
            this.switchQR = true;
            this.modoqr = 1;
          } else {
            this.switchQR = false;
            this.modoqr = 2;
          }

          this.getGenerarQR().then((result) => {
            this.modoqr = result.data.value;
            if (this.modoqr === 1) {
              this.modoqr = 1;
              this.switchQR = true;
              this.form.valorQR = 2;
              this.qr_security_code = result.data.item;
              this.msjQR = 'Desea Anular el código de segurdad QR';
            } else {
              this.modoqr = 2;
              this.switchQR = false;
              this.form.valorQR = 1;
              this.msjQR = 'Desea generar el código de seguridad QR';
            }
          });
        });
    },
    getAfiliacionQR() {
        const url = `${this.apiURLBase}/${this.enterprise.id}/others/afiliacionQR`;
        return window.axios.get(url);
    },
    getGenerarQR() {
        const url = `${this.apiURLBase}/${this.enterprise.id}/others/generarQR`;
        return window.axios.get(url);
    },
    store() {
      this.loading = true;
      window.axios({
        method: this.method,
        url: this.URL,
        data: this.form,
      })
      .then(() => {
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    save() {
      this.validate(); // someValue
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
        this.store();
      }
    },
  },
};
</script>
